// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7d2765373cd3c4318c18","691":"7bdcc71ff19c9dff5ca8"}[chunkId] + ".js";
};